module.exports = __webpack_public_path__ + "static/courses-ca31f86f6098879ee0d2269e5d779ecc.png";